<template>
    <b-button variant="danger" @click="confirmarNaoAtesto()"
        ><i class="fa fa-times-circle-o"></i> Não Atesto</b-button
    >
</template>

<script>
import AtestosServicos from './AtestosServicos'

export default {
    props: {
        atesto: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarNaoAtesto() {
            this.$swal({
                title: 'Não Atesto',
                html: `Confirma o NÃO ATESTO do documento ${this.atesto.documento}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: 'Informe a justificativa do NÃO ATESTO',
                inputValidator: value => {
                    if (!value) {
                        return 'A justificativa do NÃO ATESTO é obrigatória'
                    }
                }
            }).then(result => {
                if (result.value) {
                    this.naoAtestar(result.value)
                }
            })
        },

        naoAtestar(justificativa) {
            this.$store.dispatch('addRequest')
            let naoAtestoDto = {
                idRegistroAtestoPagamento: this.atesto
                    .idRegistroAtestoPagamento,
                problemas: this.atesto.problemas,
                justificativaNaoAtesto: justificativa
            }
            AtestosServicos.naoAtestar(naoAtestoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.$emit('atualizarErros', response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Registro atualizado com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterAtestosAtualizados')
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
